export function StatusStrip() {
  return (
    <div className="status-strip" data-screen-label="00b Status">
      <div className="wrap row">
        <span className="live">Alpha privée — accès sur invitation</span>
        <span className="seq">
          Apple · Deezer · SoundCloud · YouTube
          <span style={{ color: 'var(--cream-4)' }}> · et d'autres à venir</span>
        </span>
      </div>
    </div>
  );
}
